module.exports = __webpack_public_path__ + "img/eb94e3e.png";